"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_UPSELL_NOT_APPROVED = void 0;
exports.CREDIT_BUILDER_UPSELL_NOT_APPROVED = {
    HEADER: 'Thanks for considering Flex',
    BODY: 'Unfortunately, since we couldn’t find a good fit, we’re not able to offer you Flex service right now.',
    CTA: 'Learn more'
};
